import { useMemo as c } from "react";
const a = (e) => {
  let r = "pending", n, o;
  const u = e.then(
    (t) => {
      r = "success", n = t;
    },
    (t) => {
      r = "error", o = t;
    }
  );
  return {
    read() {
      if (r === "pending") throw u;
      if (r === "error") throw o;
      return n;
    }
  };
}, s = /* @__PURE__ */ new WeakMap(), d = (e) => c(() => (s.has(e) || s.set(e, a(e())), s.get(e)), [e]).read(), i = (e, r = 1e3) => {
  setTimeout(() => {
    s.delete(e);
  }, r);
};
export {
  i as uncacheSuspenseResource,
  d as useSuspenseResource
};
